// extracted by mini-css-extract-plugin
module.exports = {"icon":"InfoTextDark_icon__21MC2","text":"InfoTextDark_text__1GH5G"};